/** @jsx jsx */
import { jsx } from '@emotion/react'
import { OndeEstamosStyles } from '../assets/styles/OndeEstamos.styles'
import { Col, Container, Row } from 'react-bootstrap'
import { input, form } from "../assets/styles/FormSection.styles";
import FormImg from '../assets/images/LP-arabe/imagem-form.png'
import FormImgM from '../assets/images/LP-arabe/imagem-form-m.png'

const OndeEstamosContent = () => {
  return (
    <section css={OndeEstamosStyles}>
      <Container>
        <Row data-aos="fade-down" data-aos-delay="500" className='title-sec'>
          <Col lg={5} md={5} sm={12}>
            <h2><span>Onde</span> estamos</h2>
            <p>R. Palestina, 680 - Parque Monjolo, Foz do Iguaçu / PR, 85864-430</p>
          </Col>
          <Col lg={2} md={2} sm={12} />
          <Col lg={5} md={5} sm={12}>
            <p>Estamos localizados em uma área de fácil acesso, no coração de Foz do Iguaçu. Nossa escola recebe estudantes de todas as regiões da cidade, com um espaço acolhedor e seguro para toda a comunidade escolar.</p>
          </Col>
        </Row>
        <Row data-aos="fade-left" data-aos-delay="300">
          <Col lg={12} md={12} sm={12} >
            <div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4378.786570460463!2d-54.5818504238737!3d-25.520250577504356!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f69068fde66f89%3A0xee5afa7b3afa772!2sCol%C3%A9gio%20%C3%81rabe%20Brasileiro!5e1!3m2!1spt-BR!2sbr!4v1759511576659!5m2!1spt-BR!2sbr" style={{ borderRadius: 24 }} width="100%" height="260" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" />
            </div>
          </Col>
        </Row>
        <Row data-aos="fade-down" data-aos-delay="500" className='form-sec' id="fale-conosco">
          <Col lg={1} md={1} sm={12} />
          <Col lg={5} md={5} sm={12} className="d-none d-lg-block">
            <img src={FormImg} />
          </Col>
          <Col lg={12} md={12} sm={12} className="d-block d-lg-none" style={{ margin: '32px 0' }}>
            <img src={FormImgM} />
          </Col>
          <Col lg={1} md={1} sm={12} />
          <Col lg={4} md={4} sm={12}>
            <h2>Fale conosco</h2>
            <p style={{ marginBottom: 24 }}>Quer saber mais sobre a Escola Árabe Bertoni? Preencha o formulário e fale com a nossa equipe!</p>
            <div>
                <form
                  name='fale-conosco'
                  method='POST'
                  action='/sucesso'
                  data-netlify='true'
                  css={form}
                >
                  <input
                    type='hidden'
                    name='form-name'
                    value='fale-conosco'
                  />
                  <div className='text_input_containe'>
                    <div>
                      <label className='text-label'>Nome</label>
                      <input
                        className='text_input'
                        type="text"
                        name="nome"                        
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>E-mail</label>
                      <input
                        className='text_input'
                        type="mail"
                        name="email"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Celular</label>
                      <input
                        className='text_input'
                        type="tel"
                        name="celular"
                        required
                      />
                    </div>
                    <div css={input}>
                      <label className='text-label'>Mensagem</label>
                      <textArea
                        className='text_input'
                        type="text"
                        name="mensagem"
                        required
                      />
                    </div>
                    <div className='form-info'>Se quiser agendar uma visita, informe seus dados e escolha uma data. Nosso time entrará em contato em breve para confirmar o agendamento.</div>
                    <div>
                      <label className="form-checbox">
                        <input type="checkbox" name="visita"  />
                        Desejo agendar uma visita
                      </label>
                    </div>
                    <div css={input}>
                      <label className='text-label'>Escolha a data:</label>
                      <input
                        className='text_input'
                        type="date"
                        name="data"
                        required
                      />
                    </div>
                  </div>
                  <button type='submit' style={{ marginTop: 24 }}>
                    Solicite contato
                  </button>
                </form>
              </div>
          </Col>
          <Col lg={1} md={1} sm={12} />
        </Row>
      </Container>
      {/* <img src={studentWithTeacher} alt="Crianças juntas com a professora" /> */}
    </section>
  )
}

export default OndeEstamosContent;
